import * as React from 'react';
import {Datagrid, FunctionField, List, NumberField, TextField} from 'react-admin';
import {RiskCategoryEdit} from './risk-category.edit.component';
import {RiskCategoryIconPreview} from './risk-category-icon-preview.component';

export const RiskCategoryList = () => (
  <List sort={{field: 'sortWeight', order: 'ASC'}} exporter={false}>
    <Datagrid className="oddRow" rowClick="edit" expand={RiskCategoryEdit} bulkActionButtons={false}>
      <TextField source="displayName" />
      <NumberField source="sortWeight" />
      <FunctionField label="Ikon" render={(record: any) => <RiskCategoryIconPreview compact record={record} />} />
    </Datagrid>
  </List>
);
